/**
 * Client documents (CLIENT_DOCUMENTS_PLAN.md): the client's documents and how many wait for their
 * signature (the Documents badge and the Dashboard card). Loaded at sign-in, then reloaded on WS
 * `documents_changed`.
 */
import { useEffect } from 'react';
import type { ClientDocumentsList } from '@platform/shared';
import { api } from '../lib/api';
import { createStore, useStore } from '../lib/store';
import { useMe } from './session';

export const documentsStore = createStore<{ list: ClientDocumentsList | null }>({ list: null });

export async function loadDocuments() {
  try {
    documentsStore.set({ list: await api.get<ClientDocumentsList>('/api/documents') });
  } catch {
    /* the badge just stays as it was */
  }
}

/** Mount once: (re)load when the signed-in user changes. Staff and dealers have no documents. */
export function useDocumentsSync() {
  const me = useMe();
  const userId = me?.role === 'user' ? me.id : null;
  useEffect(() => {
    documentsStore.set({ list: null });
    if (userId) void loadDocuments();
  }, [userId]);
}

export const useDocuments = () => useStore(documentsStore, (s) => s.list);
export const usePendingDocuments = () => useStore(documentsStore, (s) => s.list?.pending ?? 0);
